import { Play } from 'lucide-react'
import { useEffect, useState } from 'react'
import type { Exercise } from '../domain/types'
import { Artwork } from './Artwork'

export function ExerciseMedia({ exercise, size = 68, controls = false }: { exercise: Exercise; size?: number; controls?: boolean }) {
  const [source, setSource] = useState('')

  useEffect(() => {
    if (!exercise.media) {
      setSource('')
      return
    }
    const url = URL.createObjectURL(exercise.media)
    setSource(url)
    return () => URL.revokeObjectURL(url)
  }, [exercise.media])

  if (!source) {
    if (exercise.imagePath) {
      return (
        <div className={`exercise-media built-in ${controls ? 'with-controls' : ''}`} style={{ '--media-size': `${size}px` } as React.CSSProperties}>
          <img src={exercise.imagePath} alt={`Ilustración de ${exercise.name}`} loading="lazy" />
          {safeVideoUrl(exercise.videoUrl) && <span className="media-play-badge"><Play size={11} fill="currentColor" /></span>}
        </div>
      )
    }
    return (
      <div className="exercise-media-fallback">
        <Artwork exercise={exercise} size={size} />
        {safeVideoUrl(exercise.videoUrl) && <span className="media-play-badge"><Play size={11} fill="currentColor" /></span>}
      </div>
    )
  }

  const isVideo = exercise.mediaType?.startsWith('video/')
  return (
    <div className={`exercise-media ${controls ? 'with-controls' : ''}`} style={{ '--media-size': `${size}px` } as React.CSSProperties}>
      {isVideo
        ? <video src={source} controls={controls} muted={!controls} playsInline preload="metadata" />
        : <img src={source} alt={`Referencia de ${exercise.name}`} />}
      {isVideo && !controls && <span className="media-play-badge"><Play size={11} fill="currentColor" /></span>}
    </div>
  )
}

export function safeVideoUrl(value?: string) {
  if (!value) return undefined
  try {
    const url = new URL(value)
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined
  } catch {
    return undefined
  }
}
